import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import nestedRouter from './modules/nested'
// import salesItemRefDataMainRouter from './modules/salesItemRefDataMain'
// import salesItem from './modules/salesItem'
// import shopSales from './modules/shopSales'
// import tag from './modules/tag'
import shopMenu from './modules/shop'

// modules
import goodsMenu from './modules/goods'
import marketMenu from './modules/market'
import agentMenu from './modules/agent'
import chefMenu from './modules/chef'
import spreadMenu from './modules/spread'
// import system from './modules/system'
import userMenu from './modules/user'
import partnerMenu from './modules/partnerMenu'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/dashboard/index'),
        name: 'home',
        // meta: { title: 'home', icon: 'dashboard', affix: true }
        meta: { title: 'navbar.HomeText', icon: 'dashboard', affix: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

export const hideWhenNoCildren = (data) => {
  const data2 = data
  let hasChild = false
  if (data2.children != null && data2.children.length !== 0) {
    data2.children.map(item => {
      if (item.hidden != null && item.hidden === false) {
        hasChild = true
      }
    })
  }
  data2.hidden = !hasChild
  return data2
}

export const asyncRoutes = [
  hideWhenNoCildren(shopMenu),
  hideWhenNoCildren(goodsMenu),
  hideWhenNoCildren(marketMenu),
  hideWhenNoCildren(agentMenu),
  hideWhenNoCildren(chefMenu),
  hideWhenNoCildren(spreadMenu),
  hideWhenNoCildren(userMenu),
  hideWhenNoCildren(partnerMenu),
  { path: '*', redirect: '/home', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL, // this gets the value from publicPath
  routes: constantRoutes
})

const router = createRouter()

router.beforeEach((to, from, next) => {
  // Redirect if fullPath begins with a hash (ignore hashes later in path)
  if (to.fullPath.substr(0, 2) === '/#') {
    const path = to.fullPath.substr(2)
    next(path)
    return
  }
  next()
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
